import { useState, KeyboardEvent } from 'react';
import './BizAgentInput.scss';
import { useTranslation } from 'react-i18next';

interface BizAgentInputProps {
	onSendMessage: (message: string) => void;
	disabled?: boolean;
	inputRef?: React.RefObject<HTMLTextAreaElement>;
	placeholder?: string;
}

const BizAgentInput = ({ onSendMessage, disabled = false, inputRef, placeholder }: BizAgentInputProps) => {
	const { t } = useTranslation();
	const [message, setMessage] = useState('');

	const handleSend = () => {
		if (message.trim() && !disabled) {
			onSendMessage(message.trim());
			setMessage('');
		}
	};

	const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault();
			handleSend();
		}
	};

	return (
		<div className='biz-agent-input'>
			<div className='biz-agent-input-container'>
				<textarea
					value={message}
					onChange={(e) => setMessage(e.target.value)}
					onKeyPress={handleKeyPress}
					placeholder={disabled ? t('BIZAGENT.PLEASE_WAIT') : placeholder || t('BIZAGENT.TYPE_YOUR_MESSAGE')}
					disabled={disabled}
					rows={1}
					ref={inputRef}
					className='biz-agent-input-field'
				/>
				<button
					onClick={handleSend}
					disabled={disabled || !message.trim()}
					className='biz-agent-send-btn'
					title={t('BIZAGENT.SEND_MESSAGE')}
				>
					<svg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path d='M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z' fill='currentColor' />
					</svg>
				</button>
			</div>
		</div>
	);
};

export default BizAgentInput;
